// Recovered compiled webpack factory 12205. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { w: () => n });
  let n = (t) => (e) => e.test(t);
}
